const patientModes = {
    Insercion: 0,
    Actualizacion: 1,
};

export default patientModes;